"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VizPortalClientMethod_1 = require("../VizPortalClientMethod");
var Order_1 = require("../../common/Order");
var Filter_1 = require("../../common/Filter");
var Page_1 = require("../../common/Page");
var GetDestinationProjectParams = (function () {
    function GetDestinationProjectParams(contentType, startIndex) {
        this.contentType = contentType;
        this.page = new Page_1.Page().from(startIndex);
        this.filter = new Filter_1.Filter(undefined);
        var orderClauses = [{ field: 'name', ascending: true }];
        this.order = new Order_1.OrderClauses(orderClauses);
    }
    return GetDestinationProjectParams;
}());
exports.GetDestinationProjectParams = GetDestinationProjectParams;
exports.GetDestinationProjectsMethod = new VizPortalClientMethod_1.VizPortalClientMethod('getDestinationProjects');
//# sourceMappingURL=GetDestinationProjectsMethod.js.map